<template>
  <div class="searchpatent">
    <div class="tabs_searchpatent">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="专利名称" name="first">
          <el-input
            placeholder="请输入关键词、申请号/公开号、申请人/发明人、申请日/公开日、IPC分类号/CPC分类号，系统根据规则智能识别检索"
            v-model="searchFormData.searchName"
          >
            <el-dropdown :hide-on-click="false" slot="prepend"> </el-dropdown>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dropdownFn('专利名称')"
              >检索</el-button
            >
          </el-input>
          <div class="retrievalmode">
            <div class="retrievalmode_title">检索模式:自动识别</div>
            <div class="retrievalmode_ol">
              <ol>
                <li v-for="(list, index) in retrievalmodeList" :key="index">
                  {{ list.lival1 }}
                </li>
              </ol>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="专利号" name="second">
          <el-input
            placeholder="请输入关键词，在标题、摘要、权利要求和分类号中同时检索"
            v-model="searchFormData.patentNumber"
          >
            <el-dropdown :hide-on-click="false" slot="prepend"> </el-dropdown>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dropdownFn('专利号')"
              >检索</el-button
            >
          </el-input>
          <div class="retrievalmode">
            <div class="retrievalmode_title">检索模式:检索要素</div>
            <div class="retrievalmode_ol">
              <ol>
                <li v-for="(list, index) in PatentList" :key="index">
                  {{ list.lival1 }}
                </li>
              </ol>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="申请号" name="third">
          <el-input
            placeholder="请输入申请号"
            v-model="searchFormData.applicationNumber"
          >
            <el-dropdown :hide-on-click="false" slot="prepend"> </el-dropdown>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dropdownFn('申请号')"
              >检索</el-button
            >
          </el-input>
          <div class="retrievalmode">
            <div class="retrievalmode_title">检索模式:检索要素</div>
            <div class="retrievalmode_ol">
              <ol>
                <li v-for="(list, index) in Publication" :key="index">
                  {{ list.lival1 }}
                </li>
              </ol>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="公开号" name="fourth">
          <el-input
            placeholder="请输入公开号"
            v-model="searchFormData.publicationNumber"
          >
            <el-dropdown :hide-on-click="false" slot="prepend"> </el-dropdown>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dropdownFn('公开号')"
              >检索</el-button
            >
          </el-input>
          <div class="retrievalmode">
            <div class="retrievalmode_title">检索模式:公开号</div>
            <div class="retrievalmode_ol">
              <ol>
                <li v-for="(list, index) in ApplicationList" :key="index">
                  {{ list.lival1 }}
                </li>
              </ol>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="申请人" name="five">
          <el-input
            placeholder="请输入申请人"
            v-model="searchFormData.inventor"
          >
            <el-dropdown :hide-on-click="false" slot="prepend"> </el-dropdown>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dropdownFn('申请人')"
              >检索</el-button
            >
          </el-input>
          <div class="retrievalmode">
            <div class="retrievalmode_title">检索模式:申请人</div>
            <div class="retrievalmode_ol">
              <ol>
                <li v-for="(list, index) in PublicationList" :key="index">
                  {{ list.lival1 }}
                </li>
              </ol>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="发明人" name="six">
          <el-input
            placeholder="请输入发明人"
            v-model="searchFormData.applicant"
          >
            <el-dropdown :hide-on-click="false" slot="prepend"> </el-dropdown>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dropdownFn('发明人')"
              >检索</el-button
            >
          </el-input>
          <div class="retrievalmode">
            <div class="retrievalmode_title">检索模式:发明人</div>
            <div class="retrievalmode_ol">
              <ol>
                <li v-for="(list, index) in inventList" :key="index">
                  {{ list.lival1 }}
                </li>
              </ol>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import request from '../util/request'
export default {
  name: 'searchpatent',
  data() {
    return {
      checkedCities: [],
      checkedCities1: [],
      activeName: 'first',
      patentval: '', //检索
      select: '',
      china: '',
      searchList: [], //检索结果数组
      searchFormData: {
        searchName: '', //检索名称
        patentNumber: '', //专利号
        applicationNumber: '', //申请号
        publicationNumber: '', //公开号
        inventor: '', //申请人
        applicant: '', //发明人
        applicantName: '', //发明名称
      },
      checkAll1: false,
      checkAll: false,
      retrievalmodeList: [
        {
          lival1: '支持二目逻辑运算符and、or。',
        },
        {
          lival1: '多个检索词之间用空格间隔，如：智能 手机。',
        },
        {
          lival1:
            '系统默认二目逻辑运算符是and，如输入“智能 手机”，系统按照“智能 and手机”进行检索。',
        },
        {
          lival1:
            '日期支持间隔符"-"、"."，支持如下格式：YYYY-MM-DD、YYYY.MM.DD、YYYYMMDD、YYYYMM、YYYY。',
        },
        {
          lival1:
            '支持半角()算符，如输入国产 (智能 手机)，系统优先执行“智能 AND 手机”，然后将所得结果集与“国产”进行AND运算。',
        },
        {
          lival1:
            '如果检索条件中包含空格、保留关键字或运算符，需使用半角双引号，如："WILLIAMS AND LANE INC"。',
        },
      ],
      //专利号
      PatentList: [
        {
          lival1: '在标题、摘要、权利要求、IPC分类号和说明书中同时检索。',
        },
        {
          lival1: '支持二目逻辑运算符and、or、not。',
        },
        {
          lival1:
            '如果检索内容包含空格，则需加英文双引号，如"石油 输送设备"；否则系统将按照：石油 OR 输送设备 检索。',
        },
      ],
      //公开号
      ApplicationList: [
        {
          lival1:
            '公开（公告）号格式：文献的公开国+公开流水号+公布级别。例如：CN1572277A。',
        },
        {
          lival1: '输入ZL1572277A,系统会按照CN1572277A进行检索。',
        },
        {
          lival1: '支持模糊匹配，如果输入CN1572,系统会按照CN1572进行模糊检索。',
        },
        {
          lival1:
            '输入CN1580486A CN1570234A，系统会按照CN1580486A OR CN1570234A进行检索。',
        },
        {
          lival1: '支持二目逻辑运算符or、not。',
        },
      ],
      //申请号
      Publication: [
        {
          lival1: '申请号格式：文献的申请国+申请流水号。例如：CN200410082265。',
        },
        {
          lival1:
            '自动去掉校验位，如果输入CN200410082265.7，系统会按照CN20041008226进行检索。',
        },
        {
          lival1: '输入ZL200410082265,系统会按照CN200410082265进行检索。',
        },
        {
          lival1:
            '支持模糊匹配，如果输入CN200410,系统会按CN200410 进行模糊检索。',
        },
        {
          lival1:
            '输入CN200410038055 CN200410014864，系统会按照CN200410038055 OR CN200410014864进行检索',
        },
        {
          lival1: '支持二目逻辑运算符or、not。',
        },
      ],
      //申请人
      PublicationList: [
        {
          lival1:
            '如果检索条件中包含空格、保留关键字或运算符，需使用半角双引号，如“WILLIAMS AND LANE INC”。',
        },
        {
          lival1: '支持二目逻辑运算符or、not。',
        },
      ],
      //发明人
      inventList: [
        {
          lival1: '支持二目逻辑运算符and、or、not。',
        },
        {
          lival1:
            '如果检索内容包含空格，则需加英文双引号，如"张三 李四"；否则系统将按照：张三 OR 李四 检索。',
        },
      ],
      //发明名称
      inventName: [
        {
          lival1: '支持二目逻辑运算符and、or、not。',
        },
        {
          lival1:
            '如果检索内容包含空格，则需加英文双引号，如"石油 输送设备"；否则系统将按照：石油 OR 输送设备 检索。',
        },
      ],

      isIndeterminate: false,
      isIndeterminate1: false,
    }
  },
  computed: {
    allEmpty() {
      for (let key in this.searchFormData) {
        if (this.searchFormData[key]) {
          return false
        }
      }
      return true
    },
  },
  methods: {
    //检索查询方法
    dropdownFn(val) {
      if (this.allEmpty) {
        this.$message.error('请输入内容')
        return
      }
      console.log(val)
      request({
        url: '/api/client/common/patent/search',
        method: 'get',
        params: {
          applicant: this.searchFormData.inventor, //申请人
          applicationNum: this.searchFormData.applicationNumber, //申请号
          openNum: this.searchFormData.publicationNumber, //公开号
          patentNo: this.searchFormData.patentNumber, //专利号
          inventor: this.searchFormData.applicantName, //发明人
          patentName: this.searchFormData.searchName, //专利名称
          total: 10,
        },
      }).then((res) => {
        this.searchList = res.data
        this.$router.push({
          path: '/retrieveList',
          query: {
            searchList: JSON.stringify(this.searchList),
            searchFormData: JSON.stringify(this.searchFormData),
          },
        })
        console.log(res.data)
      })
    },
    handleClick() {},
  },
}
</script>

<style scoped>
.searchpatent {
}
.tabs_searchpatent {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
::v-deep .el-tabs__header {
  margin: 0 0 3px;
}
::v-deep .el-select .el-input {
  width: 130px;
}

::v-deep .el-tabs__item:hover {
  /* background: #3864d1;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px; */
  color: #000;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #3864d1;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: #fff;
}
::v-deep .el-input-group {
  border: 4px solid #9ea9d2;
  border-radius: 8px;
}
::v-deep .el-input__inner {
  border: transparent;
}
::v-deep .el-input-group__append button.el-button {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  background-color: #3864d1;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  color: #fff;
}
::v-deep .el-tabs--card > .el-tabs__header {
  border-bottom: 0px;
}
::v-deep .el-input-group {
  /* width: 126%; */
}
::v-deep .el-tabs__content {
  overflow: visible;
}
::v-deep .el-select .el-input__inner::placeholder {
  color: #000; /* 替换为你想要的颜色值 */
}
::v-deep .el-select .el-input .el-select__caret {
  color: #000;
}
.retrievalmode {
  margin-top: 10px;
  margin-bottom: 40px;
  height: 197px;
  width: 765px;
}
.retrievalmode_title {
  color: #3864d1;
  font-size: 16px;
}
ol {
  font-size: 13.5px;
  color: #000;
}
ol li {
  margin-bottom: 5px;
}
.retrievalmode_ol {
  margin-left: -24px;
}
::v-deep .el-input-group__prepend div.el-select .el-input__inner {
  border-radius: 8px;
}
::v-deep .el-input-group__prepend {
  background-color: #fff;
  border: 0;
}
::v-deep .el-dropdown {
  color: #000;
}
::v-deep .el-input-group__prepend div.el-select .el-input__inner,
.el-input-group__prepend div.el-select:hover .el-input__inner {
  background-color: #fff;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0px;
}
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-left: 0px;
}
.el-dropdown-menu {
  width: 670px;
  left: 380px !important;
}
::v-deep .popper__arrow {
  border-bottom-color: transparent !important;
}
::v-deep .popper__arrow::after {
  border-bottom-color: transparent !important;
}
.dropdown_item_4 {
  height: 150px;
}
</style>
